import { useQuery } from '@apollo/client/react';
import type { FC } from 'react';

import EditableContentContainer from '@zen/Components/EditableContentContainer';
import QueryHandler from '@zen/Components/QueryHandler';
import useAccount from '@zen/utils/hooks/useAccount';

import AnalyticsAccountSettingsLoadingSkeleton from './AnalyticsAccountSettingsLoadingSkeleton';
import AnalyticsSettingToggle from './AnalyticsSettingToggle';
import AnalyticsSharedUserSettingToggle from './AnalyticsSharedUserSettingToggle';
import {
  AnalyticsAccountSettingsDocument,
  type AnalyticsAccountSettingsQueryResult,
  type AnalyticsAccountSettingsQueryVariables
} from './graphql';
import { getInitialSettingsData } from './helpers';
import type { AccountAnalyticsSettings } from './types';

const AnalyticsSettingsDetails: FC = () => {
  const { accountUuid: accountId } = useAccount();
  const { data, loading } = useQuery<AnalyticsAccountSettingsQueryResult, AnalyticsAccountSettingsQueryVariables>(
    AnalyticsAccountSettingsDocument,
    {
      variables: { accountId },
      fetchPolicy: 'no-cache'
    }
  );

  return (
    <QueryHandler
      data={data?.analyticsAccountSettings || getInitialSettingsData(accountId)}
      error={false}
      isLoading={loading}
      loadingComponent={<AnalyticsAccountSettingsLoadingSkeleton />}
    >
      {(analyticsSettings: AccountAnalyticsSettings) => {
        return (
          <EditableContentContainer heading="Analytics">
            <div className="col-span-8 xl:col-span-6 flex flex-col gap-4">
              <AnalyticsSettingToggle settings={analyticsSettings} />
              <AnalyticsSharedUserSettingToggle settings={analyticsSettings} />
            </div>
          </EditableContentContainer>
        );
      }}
    </QueryHandler>
  );
};

export default AnalyticsSettingsDetails;
